(function () {
  // Interruttore dello scorrimento automatico (5 secondi). Metterlo a false
  // ferma lo slider sulla slide corrente: comodo per lavorare su una singola
  // slide senza che scappi via mentre si guarda.
  var SCORRIMENTO_AUTOMATICO = true;

  document.querySelectorAll('[data-hero-slider]').forEach(function (hero) {
    var slides = Array.from(hero.querySelectorAll('.bdr-hero__slide'));
    var dots   = Array.from(hero.querySelectorAll('.bdr-hero__dot'));
    var prevBtn = hero.querySelector('.bdr-hero__prev');
    var nextBtn = hero.querySelector('.bdr-hero__next');

    if (slides.length < 2) return;

    var current = 0;
    var timer = null;

    function goTo(n) {
      slides[current].classList.remove('is-active');
      if (dots[current]) dots[current].classList.remove('is-active');
      current = ((n % slides.length) + slides.length) % slides.length;
      slides[current].classList.add('is-active');
      if (dots[current]) dots[current].classList.add('is-active');
    }

    function startAutoplay() {
      clearInterval(timer);
      if (!SCORRIMENTO_AUTOMATICO) return;
      timer = setInterval(function () { goTo(current + 1); }, 5000);
    }

    if (prevBtn) prevBtn.addEventListener('click', function () { goTo(current - 1); startAutoplay(); });
    if (nextBtn) nextBtn.addEventListener('click', function () { goTo(current + 1); startAutoplay(); });

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        goTo(parseInt(dot.dataset.index, 10));
        startAutoplay();
      });
    });

    var touchStartX = 0;
    hero.addEventListener('touchstart', function (e) {
      touchStartX = e.changedTouches[0].clientX;
    }, { passive: true });
    hero.addEventListener('touchend', function (e) {
      var delta = e.changedTouches[0].clientX - touchStartX;
      if (Math.abs(delta) < 50) return;
      goTo(delta < 0 ? current + 1 : current - 1);
      startAutoplay();
    }, { passive: true });

    startAutoplay();
  });
})();
